import { getMetricPrimaryColor, getMetricSecondaryColor } from "@Containers/app/stat-cards/tooltips/get-metric-colors";
import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import UserProgressStats from "@Enums/UserProgressStats";
import { Box, LinearProgress, linearProgressClasses, LinearProgressProps, styled } from "@mui/material";

interface IBybProgressBar extends LinearProgressProps {
  metricType?: MetricEventTypes | UserProgressStats | MetricFilterTypes;
}

interface IBybProgressBarTarget {
  targetPosition: number;
  metricType: MetricEventTypes | UserProgressStats | MetricFilterTypes;
}

export const BybProgressBar = styled(LinearProgress)<IBybProgressBar>(({ metricType, theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: getMetricSecondaryColor(metricType!, theme),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: getMetricPrimaryColor(metricType!, theme),
  },
}));

export const BybProgressBarTarget = styled(Box)<IBybProgressBarTarget>(({ targetPosition, metricType, theme }) => ({
  position: "absolute",
  left: `${targetPosition}%`,
  top: 0,
  width: theme.spacing(0.75),
  height: theme.spacing(2.5),
  borderRadius: theme.spacing(2),
  backgroundColor: `${getMetricPrimaryColor(metricType!, theme)}`,
  border: `1px solid ${getMetricSecondaryColor(metricType!, theme)}`,
  transform: "translate(-50%, -25%)",
  zIndex: 1,
}));
